import { createTheme } from '@mui/material/styles';

/**
 * Pineapple's colours, as the storefront uses them (signup/src/custom.scss).
 * The portal is Pineapple's own now that Pineapple is splitting from DGtek, so
 * it wears Pineapple's colours rather than DGtek's navy.
 */
export const brand = {
  /** PN Green: the brand colour, and every primary action. */
  green: '#03793E',
  /** A deeper PN Green for large surfaces such as the sidebar, where white
   * text needs more contrast than PN Green itself gives. */
  greenDark: '#025C2F',
  /** PN Yellow: the accent. Black text on it, never white. */
  yellow: '#F5E748',
  ink: '#000000',
  /** The quiet line under the white top bar. */
  rule: '#E3E3E3',
};

/**
 * Status colours. MUI's error and success pass as small white text on a chip
 * (5.0:1 and 5.1:1); its info (3.9:1) and warning (3.1:1) do not, and those are
 * the two order statuses staff read most, Scheduled and Cancellation
 * requested. Both are darkened to pass. The storefront's own reds and greens
 * are not readable as small text on a chip either, so they are not used here.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: brand.green,
      dark: brand.greenDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: brand.yellow,
      contrastText: brand.ink,
    },
    // White text on these: 4.8:1 and 5.0:1.
    info: { main: '#0277BD' },
    warning: { main: '#B45309' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // The storefront's buttons are pills; the portal's follow.
        root: {
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default theme;
